import { createContext, useContext, useEffect, useState } from "react";

const ShoppingCartContext = createContext();

export const ShoppingCartProvider = ({ children }) => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isOpen, setIsModalOpen] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isDiscardModalOpen, setDiscardModalOpen] = useState(false);
  const [bagItems, setBagItems] = useState([]);
  const [bagItemsLoader, setBagItemsLoader] = useState(false);
  const [userDetails, setUserdetails] = useState([]);
  const [tripDetails, setTripDetails] = useState([]);
  const [isSelectedProductExistInCart, setSelectedProductExistInCart] = useState(false);

  useEffect(()=>{
    if(bagItems?.length > 0){
      sessionStorage.setItem("orderData",JSON.stringify(bagItems))}
  },[bagItems])

  const openModal = (product= null, trip = null, editTrip = false) => {
    if((!product && !trip) || editTrip){
      setIsFormOpen(true);
      setDiscardModalOpen(false);
    } else
    if(!product && trip){
      setDiscardModalOpen(true);
      setIsFormOpen(false);
    } else {
      setIsFormOpen(false);
      setDiscardModalOpen(false);
    }
    setSelectedProduct(product);
    setIsModalOpen(true);
  };

  const onClose = () => {
    setIsModalOpen(false);
    setSelectedProduct(null);
  };

  return (
    <ShoppingCartContext.Provider value={{ bagItemsLoader, setBagItemsLoader, tripDetails, setTripDetails, userDetails, setUserdetails, isSelectedProductExistInCart, setSelectedProductExistInCart, bagItems, setBagItems, selectedProduct, isOpen, openModal, onClose, isFormOpen, setIsFormOpen, isDiscardModalOpen, setDiscardModalOpen }}>
      {children}
    </ShoppingCartContext.Provider>
  );
};

export const useShoppingCart = () => useContext(ShoppingCartContext);
